import { apiPermissionTree, PermissionItemProps, PermissionTreeItemProps } from "apis";
import { lazy, useEffect } from "react";
import { Outlet, useSearchParams } from "react-router-dom";
import useAppSelector from "hooks/useAppSelector";
import { useDispatch } from "react-redux";
import { onSelected } from "store/permission";


export const PageAdminPermission = lazy(() => import("./List"));
export const PageAdminPermissionCreate = lazy(() => import("./Add"));
export const PageAdminPermissionUpdate = lazy(() => import("./Edit"));
export const PageAdminPermissionManager = lazy(() => import("./AccessControll/PermissionAccessControll"));

export interface FormPermissionValuesProps extends PermissionItemProps {
    parentId?: number;
}

export const PageAdminPermissionContainer = () => {
    const [searchParams] = useSearchParams();
    const permission = useAppSelector(state => state.permission);
    const dispatch = useDispatch();

    useEffect(() => {
        apiPermissionTree()
    }, [])


    function findPermissionById(
        data: PermissionTreeItemProps[],
        id: number
    ): PermissionTreeItemProps | null {
        for (const item of data) {
            if (item.id === id) {
                return item;
            }

            if (item.children?.length) {
                const found = findPermissionById(item.children, id);
                if (found) return found;
            }
        }

        return null;
    }

    const _pId = searchParams.get("parentId");
    const pId = _pId && !isNaN(parseInt(_pId)) ? parseInt(_pId) : undefined;

    useEffect(() => {
        const p = findPermissionById(permission.tree.data, pId || -1);
        if (p) {
            dispatch(onSelected({ item: p }));
        }
        else {

            dispatch(onSelected({}));
        }
    }, [pId, permission.tree.data])

    return <Outlet />
}